import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AreaManagement = ({ children }) => {
  const Navigate = useNavigate();


  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin/area") {
      Navigate("/admin/area/area-tables");
    }
  }, [location, Navigate]);

  return (
    <div className="mt-4 ">
      <section>
        <div className="container">
          <div className="row">
            {children}
            {/* Add your store management components here */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AreaManagement;
